import { ReactNode } from "react";

interface CsvUtilLayoutProps {
  children: ReactNode;
}

export const CsvUtilLayout = ({ children }: CsvUtilLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-[1400px] mx-auto py-8 space-y-8">
        {children}
      </div>
    </div>
  );
};